import { Route } from '@angular/router';
import { authGuard } from '@call-center/core'; 
import { permissionGuard } from '@call-center/core/permission';
export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadChildren: () =>
      import('@call-center/features/auth').then((m) => m.FEATURES_AUTH_ROUTES),
    title: 'Login',
  },
  {
    path: 'dashboard',
    canActivate: [authGuard,permissionGuard],
    loadChildren: () =>
      import('@call-center/features/dashboard').then((m) => m.dashboardRoutes),
    title: 'Dashboard',
  },
  {
    path: 'contacts',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@call-center/features/contact').then(
        (m) => m.FEATURES_CONTACT_ROUTES
      ),
    title: 'Contacts',
  },
  {
    path: 'analytics',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@call-center/features/ai').then(
        (m) => m.FEATURES_ANALYTICS_ROUTES
      ),
    title: 'Analytics',
  },
  {
    path: 'call-management',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@call-center/features/call-management').then(
        (m) => m.FEATURES_CALL_MANAGEMENT_ROUTES
      ),
    title: 'Call Management',
  },
  {
    path: 'question',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@call-center/features/question').then(
        (m) => m.FEATURES_QUESTION_ROUTES
      ),
    title: 'Question',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth',
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
